import React, { Dispatch, useEffect } from 'react';
import { TimeToLive } from '../interfaces';
import Xarrow, { Xwrapper } from 'react-xarrows';
import Draggable from 'react-draggable';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import { NODE_CONNECTOR_COLOR, NODE_HIGHLIGHT_COLOR } from './NodeWrapper';

interface TTLDotsProps {
    ttlId: number;
    srcNodeId: string;
    updateXarrow: any;
    ttl: TimeToLive;
    showDeleteTTL: boolean;
    deleteLine: () => void;
    nodeHeight: string;
    setTranslate: Dispatch<string>;
    translate: string;
    deleteLeft: string;
    deleteTop: string;
  }

const TTLDotsDiv: React.FC<TTLDotsProps> = ({ ttlId, srcNodeId, updateXarrow, ttl, showDeleteTTL, deleteLine, nodeHeight, setTranslate, translate, deleteLeft, deleteTop }) => {

    const [, updateState] = React.useState<any>();
    const forceUpdate = React.useCallback(() => updateState({}), []);

    useEffect(() => {
        let clickTTL1: HTMLElement = document.getElementById(`ttl${srcNodeId}${ttlId}1`)!;
        let clickTTL2: HTMLElement = document.getElementById(`ttl${srcNodeId}${ttlId}2`)!;
        let deleteTTL: HTMLElement = document.getElementById(`deletettl${srcNodeId}${ttlId}`)!;

        if (ttl.nextNodeId !== '') {
            if (clickTTL1 !== null && clickTTL2 !== null && deleteTTL !== null) {
                const txpSvg: HTMLElement = clickTTL2.nextElementSibling as HTMLElement;
                const path = txpSvg.querySelector('svg path');
                if (path !== null) {
                    const highlightPath = () => {
                        txpSvg.style.zIndex = '23001';
                        path.setAttribute('stroke', NODE_HIGHLIGHT_COLOR);
                    };
                    const resetPath = () => {
                        txpSvg.style.zIndex = ''
                        path.setAttribute('stroke', NODE_CONNECTOR_COLOR);
                    }

                    clickTTL1.addEventListener('mouseover', highlightPath);
                    clickTTL2.addEventListener('mouseover', highlightPath);
                    clickTTL1.addEventListener('mouseout', resetPath);
                    clickTTL2.addEventListener('mouseout', resetPath);
                }

                const nodes: NodeListOf<Element> = document.querySelectorAll('.node')!;
                if (nodes !== null) {
                    let allNodes1: HTMLElement[] = Array.from(nodes) as HTMLElement[];
                    
                    let nodeToConnect = allNodes1.filter((node: HTMLElement) => node.dataset.id === ttl.nextNodeId)
                    
                    if (nodeToConnect[0] !== undefined) {
                        let connectedDot = nodeToConnect[0].querySelector('.node-dot1')
                        let sourceNode = allNodes1.filter((node: HTMLElement) => node.dataset.id === srcNodeId)
                        let coaInject = sourceNode[0].querySelector('.coa-inject')
                        if (coaInject !== null) {
                            const TTLX: string = (connectedDot!.getBoundingClientRect().x - clickTTL1.getBoundingClientRect().x) + 'px'
                            const TTLY: string = (connectedDot!.getBoundingClientRect().y - clickTTL1.getBoundingClientRect().y) + 'px'

                            setTranslate('translate('+TTLX+', '+TTLY+')');
                        }
                    }
                }
            }
        }
        
    }, [ttl.nextNodeId, nodeHeight])  // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        forceUpdate()
    }, [translate])  // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div id={`wrapttl${srcNodeId}${ttlId}1`} className="ttl-dots-wrapper" data-id="1">
            <div id={`deletettl${srcNodeId}${ttlId}`} className="delete-line" onClick={deleteLine} style={{ top: deleteTop, left: deleteLeft }}><div className="delete-line-inner" style={{ visibility: showDeleteTTL ? 'visible' : 'hidden' }}>Delete Line</div></div>
            <Xwrapper>
                { ttl.nextNodeId === '' ? <Draggable onDrag={updateXarrow} onStop={updateXarrow}>
                    <div id={`ttl${srcNodeId}${ttlId}1`} className={`drag-elem1`}></div>
                </Draggable> : <div id={`ttl${srcNodeId}${ttlId}1`} className={`drag-elem1`}></div> }
                { ttl.nextNodeId === '' ? <Draggable onDrag={updateXarrow} onStop={updateXarrow}>
                 <div id={`ttl${srcNodeId}${ttlId}2`} className={`drag-elem2`} data-tooltip-id={`coa-tooltip${srcNodeId}${ttlId}2`} data-tooltip-content="Drag to a Node" data-tooltip-place="top"></div></Draggable> : <div id={`ttl${srcNodeId}${ttlId}2`} className={`drag-elem2`} style={{ transform: translate }}></div> }
                
                <Xarrow start={`ttl${srcNodeId}${ttlId}1`} end={`ttl${srcNodeId}${ttlId}2`} showHead={false} color={NODE_CONNECTOR_COLOR} />
            </Xwrapper>
            <Tooltip id={`coa-tooltip${srcNodeId}${ttlId}2`} className="sidemenu-tooltip" />
        </div>
    )
}

export default TTLDotsDiv;